// extracted by mini-css-extract-plugin
export var container = "styles-module--container--JEFho";
export var imgMain = "styles-module--imgMain--+et3x";
export var containerText = "styles-module--containerText--mfOz4";
export var signupButton = "styles-module--signupButton--VJ0Jm";